import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getAggregateBranchSalesInventory, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import reportsUtil from 'utils/reportsApi';
import Grid from 'screens/components/basic/Grid';
import { reportAggregateBranchSalesInventoryCrumb } from 'utils/breadcrumbInfo';
import PageHeader from 'screens/components/basic/PageHeader';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';

class AggregateBranchSalesInventory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 12,
            showBody: false,
            totalRow: 0
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `AggregateBranchSalesInventoryBeginDate`);
        this.props.formInput(date, `AggregateBranchSalesInventoryEndDate`);
        if (localStorage.getItem("AggregateBranchSalesInventoryBranchIds") != null) {
            this.props.formInput(localStorage.getItem("AggregateBranchSalesInventoryBranchIds").split(","), "AggregateBranchSalesInventoryBranchIds")
        }

    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedBranchIds != undefined && this.props.selectedBranchIds != prevProps.selectedBranchIds) {
            localStorage.setItem("AggregateBranchSalesInventoryBranchIds", this.props.selectedBranchIds)
        }
    }

    componentWillReceiveProps = (newProps) => {
        if (this.state.showBody) {
            const totalRow = newProps.aggregateBranchSalesInventory && newProps.aggregateBranchSalesInventory.data && newProps.aggregateBranchSalesInventory.data.length > 0 ? newProps.aggregateBranchSalesInventory.data.slice(-1)[0].totalRows : 0;
            this.setState({ totalRow: totalRow });
            if (newProps.aggregateBranchSalesInventory && newProps.aggregateBranchSalesInventory.includeInventoryValue == 0) {
                this.setState({ itemsPerPage: 31 })
            }
            if (newProps.aggregateBranchSalesInventory && newProps.aggregateBranchSalesInventory.includeInventoryValue == 1) {
                this.setState({ itemsPerPage: 12 })
            }
        }
    }

    cleanSearch = () => {
        this.props.clearFormInput(`AggregateBranchSalesInventoryBeginDate`);
        this.props.clearFormInput(`AggregateBranchSalesInventoryEndDate`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');

        let selectedDateRangeType = this.props.selectedDateRangeType;
        let branchIds = this.props.selectedBranchIds.join(",");
        let dateGroupBy = this.props.selectGroupBy || "Month";
        let includeInventoryValue = this.props.includeInventoryValue ? 1 : 0;

        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/aggregateBranchSalesInventory?beginDate=${beginDate}&endDate=${endDate}&branchIds=${branchIds}&dateGroupBy=${dateGroupBy}&selectedDateRangeType=${selectedDateRangeType}&includeInventoryValue=${includeInventoryValue}`, "aggregateBranchSalesInventory");
        }
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');

        let selectedDateRangeType = this.props.selectedDateRangeType;
        let branchIds = this.props.selectedBranchIds.join(",");
        let dateGroupBy = this.props.selectGroupBy || "Month";
        let includeInventoryValue = this.props.includeInventoryValue ? 1 : 0;
        let pageNumber = this.state.activePage;
        let pageSize = this.props.includeInventoryValue ? 12 : 31;
        this.props.getAggregateBranchSalesInventory({ beginDate, endDate, branchIds, dateGroupBy, selectedDateRangeType, includeInventoryValue, pageNumber, pageSize });
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }


    render() {
        return (
            <Grid headerContent={reportAggregateBranchSalesInventoryCrumb}>
                <PageHeader title={LOOKUP.report.AggregateBranchSalesInventory.text} 
                    description={LOOKUP.report.AggregateBranchSalesInventory.description}
                />
                <Header
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    branchOptions={this.props.branchOptions}
                    groupByOptions={this.props.groupByOptions}
                    dateRangeTypeOptions={this.props.dateRangeTypeOptions}
                    selectedDateRangeType={this.props.selectedDateRangeType}
                />
                {
                    this.state.showBody &&
                    <p className="text-right mt-2 blue-text">
                        <i>Generated on : {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
                    </p>
                }
                {
                    this.state.showBody && this.props.aggregateBranchSalesInventory &&
                    <CardSimple>
                        <Body
                            aggregateBranchSalesInventory={this.props.aggregateBranchSalesInventory}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                            // selectedDetailsToInclude={this.props.selectedDetailsToInclude}
                            branches={this.props.branchOptions}
                            loggedBranch={this.props.loggedBranch}
                        />
                        <Pagination
                            length={this.state.totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }

}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let branchOptions = [];
    branches.map((item) => {
        branchOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    let groupBy =
        [
            { text: "Daily", value: "Day" },
            { text: "Monthly", value: "Month" },
            { text: "Yearly", value: "Year" }
        ];

    let dateRangeType =
        [
            { text: "Custom", value: "custom" },
            { text: "Last Year YOY", value: "last2years" }

        ]

    return {
        branchOptions: branchOptions,
        aggregateBranchSalesInventory: state.reports.aggregateBranchSalesInventory,
        loggedBranch: state.common.branchId,
        beginDate: state.form.AggregateBranchSalesInventoryBeginDate,
        endDate: state.form.AggregateBranchSalesInventoryEndDate,
        selectedBranchIds: state.form.AggregateBranchSalesInventoryBranchIds,
        selectGroupBy: state.form.AggregateBranchSalesInventoryGroupBy,
        selectedDateRangeType: state.form.AggregateBranchSalesInventoryDateRangeType,
        includeInventoryValue: state.form.AggregateBranchSalesInventoryIncludeInventoryValue,
        // selectedDetailsToInclude: state.form.SalesSummaryDetailsDetailsToInclude,

        groupByOptions: groupBy,
        dateRangeTypeOptions: dateRangeType
        // detailsToIncludeOptions: details
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getAggregateBranchSalesInventory: model => dispatch(getAggregateBranchSalesInventory(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getProductTypes: () => dispatch(getProductTypes()),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(AggregateBranchSalesInventory));